import { t } from '@lingui/core/macro';
import { validPhoneRegex } from 'shared/validators/phone.validator';
import * as yup from 'yup';

import { AuthSignInPayload } from '../interfaces/auth-sign-in-payload';

/** Сообщения — функции: yup зовёт их в момент валидации, поэтому текст берётся на текущем языке. */
export const authSignInValidator = (): yup.SchemaOf<AuthSignInPayload> =>
  yup
    .object()

    .shape({
      username: yup
        .string()
        .required(() => t`Номер телефона обязателен`)
        .matches(validPhoneRegex, () => t`Введите корректный номер телефона`),
      password: yup.string().required(() => t`Пароль обязателен`),

      to: yup.string().optional(),
    });
